import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import { useReactToPrint } from 'react-to-print';
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Image,
    Table,
    Thead,
    Tfoot,
    Tbody,
    Th,
    Tr,
    Td,
    VStack,
} from "@chakra-ui/react";
import EasyChekLogo from "assets/images/easychek_logo.jpg";
import OrdersTable from "views/Custom/OrdersTable";
import StocksTable from "views/Custom/StocksTable";
// import Pagination from "views/Custom/Pagination";
// import useGetOrders from "hooks/useGetOrders";

function StockHistory({
    isOpen,
    onClose,
    productData, 
}) {


    // useEffect(() => {
    //     if (userData && isOpen) {
    //         console.log(userData);
    //     }
    // }, [userData, isOpen]);

    // console.log(partsTotal, laborTotal);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    if (productData == null) {
        return (<></>);
    }


    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Stocks History for {productData.name}</ModalHeader>
                <ModalCloseButton />
                <ModalBody width={"100%"}p={"32px"}>
                    <Flex direction={"column"}>
                        <StocksTable 
                            productId={productData.id} 
                        />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default StockHistory;
